export default function CFormatSpecifiersOutput() {
  return <h2>C Format Specifiers Output</h2>;
}
